// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const sidebarConfig = (tiles) => {
  var items = tiles?.map((x) => {
    return {
      title: x.title,
      path: x.url,
      icon: getIcon(x.icon),
    };
  });

  return [
    {
      items,
    },
  ];
};

export default sidebarConfig;
